import { createAction, createAsyncThunk, createReducer } from '@reduxjs/toolkit';

import { getDraft } from '@app/store/transport-layer/form/drafts';
import { convertHtmlToPdf } from '@app/store/transport-layer/form/pdf/convert';
import { RootState } from '@app/store/types';

export const convertDraftToTemplate = createAction('form/convertDraftToTemplate');
export const requestSigningViaDraft = createAction('form/requestSigningViaDraft');
export const requestEditingDocumentViaDraft = createAction('form/requestEditingDocumentViaDraft ');

export const convertDraftToPdf = createAsyncThunk<
  Blob,
  { workspaceId: string; draftId: string },
  {
    rejectValue: Error;
  }
>('form/convertDraftToPdf', async ({ workspaceId, draftId }) => {
  const draft = await getDraft(workspaceId, draftId);
  return convertHtmlToPdf(draft.content);
});

interface FormState {
  isConvertingPdf: boolean;
}

const initialState: FormState = {
  isConvertingPdf: false,
};

export const reducer = createReducer(initialState, (builder) =>
  builder
    .addCase(convertDraftToPdf.pending, (state) => {
      state.isConvertingPdf = true;
    })
    .addCase(convertDraftToPdf.fulfilled, (state) => {
      state.isConvertingPdf = false;
    })
    .addCase(convertDraftToPdf.rejected, (state) => {
      state.isConvertingPdf = false;
    })
);

const getFormState = (state: RootState) => state.form;

export const getIsConvertingDraftToPdf = (state: RootState) => getFormState(state).isConvertingPdf;
